import { powerlabAccionesRoles } from '../../acciones-roles/reportes/powerlab-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const PowerLabRoutes: SideBarButton = {
  data: {
    name: 'Lab - Power BI',
    appendUrl: './reportsPBI/laboratory',
    roles: powerlabAccionesRoles.sideNavActions.powerLabPbi,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Testometric',
        url: '/testometric',
      },
      options: PreConfigButton3,
    },
  ],
};
